import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {AppComponent} from './app.component';
import {AuthentificationService} from './authentification.service';
import {TransactionsService} from './transactions.service';
import {DetailsForSupplierComponent} from './details-for-supplier.component';
import {FileDownloadService} from './file-download.service';

import {Router} from '@angular/router';

@Component({
    selector: 'remains-to-deliver-supplier',
    templateUrl: './templates/remains-to-deliver-supplier.component.html',
    styleUrls: ['./styles/remains-to-deliver-supplier.component.css'],
    providers: [AuthentificationService, AppComponent, TransactionsService, DetailsForSupplierComponent, FileDownloadService]
})
export class RemainsToDeliverSupplierComponent implements OnInit {

    brlf_list: Array<any> = [];
    brlf_details: Array<any> = [];
    brlf: any;
    number: any;
    date: any;

    ref_search: any = "";
    bcf_search: any = "";

    constructor(private app_component: AppComponent,
        private authentification_service: AuthentificationService,
        private router: Router,
        private transactions_service: TransactionsService,
        private filedownloadservice: FileDownloadService
    ) {

        this.CheckUSerSession();
        this.app_component.valTest = '/remains-to-deliver-supplier';
        this.app_component.GetParent();
    }

    CheckUSerSession(): void {
        this.authentification_service.UserCheckSession().then(result => {if (result['id_user'] === 0) {this.router.navigate(['authentification'])} });
    }

    Search(): void {
        //console.log(this.ref_search, this.bcf_search);
        this.transactions_service.SearchRemainsToDeliverSupplier('BRLF_'+this.ref_search, 'BCF_'+this.bcf_search).then(result => {this.brlf_list = result['list'];});
    }

    GetRemainsToDeliverSupplier() {
        this.transactions_service.GetRemainsToDeliverSupplier().then(result => {this.brlf_list = result['list'];});
    }

    ShowDetails(brlf: any): void {
        //console.log(brlf);
        // this.details_for_supplier.ShowInfos(brlf);  
        this.brlf = brlf;
        let id_purchase_order = brlf.id_purchase_order;
        this.transactions_service.GetPurchaseOrdersDetails(id_purchase_order).then(result => {this.number = result['infos'][0]['reference']; this.date = result['infos'][0]['creation_date']; this.brlf_details = result['list']; console.log(result['infos'][0]['reference'])});
    }


    DownloadPdf(): void {
        this.filedownloadservice.PurchaseOrder(this.brlf);

    }

    ngOnInit() {
        this.Search();
        //this.GetRemainsToDeliverSupplier();
    }

}



// WEBPACK FOOTER //
// ./src/app/remains-to-deliver-supplier.component.ts